var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-menu-container",
      attrs: { id: "result-sidebar-menu" }
    },
    [
      _c("div", { staticClass: "sidebar-main-label" }, [
        _vm._v("Сумма заказа")
      ]),
      _vm._v(" "),
      _vm.priceLoaded
        ? _c(
            "div",
            [
              _c("div", { staticClass: "sidebar-characteristics-text" }, [
                _c("span", { staticClass: "characteristics-name" }, [
                  _vm._v("Всего товаров")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "bold-text characteristics-val" }, [
                  _vm._v(_vm._s(_vm.numberProducts))
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.productsCost, function(product) {
                return [
                  _c("div", { staticClass: "sidebar-characteristics-text" }, [
                    _c("span", { staticClass: "characteristics-name" }, [
                      _vm._v(_vm._s(product.name))
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "bold-text characteristics-val" },
                      [
                        _vm._v(
                          _vm._s(
                            product.cost
                              .toString()
                              .replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, " ")
                          ) + " ₽"
                        )
                      ]
                    )
                  ])
                ]
              }),
              _vm._v(" "),
              _c("div", { staticClass: "sidebar-characteristics-text" }, [
                _c("span", { staticClass: "characteristics-name" }, [
                  _vm._v("Общая стоимость")
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "bold-text characteristics-val" }, [
                  _vm._v(_vm._s(_vm.totalCost) + " ₽")
                ])
              ])
            ],
            2
          )
        : _c("div", [
            _c("div", { staticClass: "sidebar-spinner-container" }, [
              _c("div", { staticClass: "sidebar-spinner-grid" }, [
                _c(
                  "div",
                  { staticClass: "sidebar-spinner" },
                  [_c("SpinnerTwo")],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "sidebar-spinner-text" }, [
                  _vm._v("Идёт расчёт стоимости..")
                ])
              ])
            ])
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "wide-result-button top-rounding bot-rounding",
          on: {
            click: function($event) {
              return _vm.createPDF()
            }
          }
        },
        [
          _c("SVGPrint", { staticClass: "svg-print" }),
          _vm._v(" "),
          _c("span", { staticClass: "wide-result-button-text" }, [
            _vm._v("Распечатать ваш заказ")
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }